import React, { useState } from 'react';
import { Params as UrlParams } from 'react-router';
import { useParams } from 'react-router-dom';
import { FormHelperText, Box } from '@mui/material';

import { formAPI } from 'api/form';
import FormText from './FormText';
import { FormElementControlPropsType, FormControlUniquenessTextProps } from './index';
import { processSettingsUrl } from 'components/common/form/formTools';
import { FormComponentBuilder } from 'components/common/form/layout';

export default function FormUniquenessText({
    controlProps,
    elementProps,
}: FormElementControlPropsType<FormControlUniquenessTextProps>) {
    const [error, setError] = useState('');
    const [previousValue, setPreviousValue] = useState('');

    const urlParams: UrlParams = useParams();
    const pks = Object.keys({ ...controlProps.urlParams, ...urlParams });
    const checkUrl = processSettingsUrl(controlProps.checkUrl, [...pks, 'field', 'value'], {
        ...urlParams,
        ...controlProps.urlParams,
        field: controlProps.name,
        value: controlProps.value,
    });

    const checkOnUniqueness = async () => {
        if (controlProps.value.trim().length && controlProps.value !== previousValue) {
            const response = await formAPI.load(checkUrl);
            setPreviousValue(controlProps.value);
            if (response?.data?.data?.message) {
                setError(response.data.data.message || '');
            } else {
                setError('');
            }
        }
    };

    return (
        <>
            <>
                <FormText controlProps={{ ...controlProps, onBlur: checkOnUniqueness }} elementProps={elementProps} />
            </>
            {error && <FormHelperText sx={{ color: 'red', margin: '3px !important' }}>{error}</FormHelperText>}
        </>
    );
}

export class FormUniquenessTextBuilder extends FormComponentBuilder {
    prepareProps(): FormControlUniquenessTextProps {
        return {
            ...this.controlProps,
            urlParams: {
                ...this.elementProps.urlParams,
                ...this.elementProps.componentProps?.urlParams,
            } as UrlParams,
            checkUrl: this.elementProps.componentProps?.checkUrl ?? '',
            placeholder: this.elementProps.componentProps?.placeholder ?? '',
            rows: this.elementProps.componentProps?.rows ?? 4,
            asLabel: this.elementProps.componentProps?.asLabel ?? false,
            maxLength: this.elementProps.componentProps?.maxLength,
            maxWidth: this.elementProps.componentProps?.maxWidth,
            disabled: this.elementProps.componentProps?.disabled ?? false,
            fieldType: this.elementProps.componentProps?.fieldType ?? 'text',
        };
    }
}
